import { connect } from 'react-redux';
import { auth as types } from '../constants/types';

const Logout = ({ dispatch, className }) => {
    
    const handleLogout = () => {
        if (localStorage.getItem('AUTHORIZATION_TOKEN_BLOG')) {
            localStorage.removeItem('AUTHORIZATION_TOKEN_BLOG');
            localStorage.removeItem('REFRESH_TOKEN_BLOG');
            localStorage.removeItem('user');
            
            dispatch({ type: types.LOGGED_OUT });
            window.location.href = '/'; 
        }
    }
    return (
        <a className={className || "link"} onClick={handleLogout}>
            Logout
        </a>
    );
}

export default connect()(Logout);